import isEqual from 'lodash/isEqual'

import { transformValue } from './transformers'

const getConfig =
  state =>
  ({ name, key }) => {
    if (name) return state.configs.find(c => c.name === name)
    if (key) return state.configs.find(c => c.key === key)
  }

const isVisibleByUserId =
  (_, getters) =>
  ({ name, userId }) => {
    const config = getters.getConfig({ name })
    if (!config?.active) return false
    if (config.public) return true
    return config.value.includes(userId)
  }

const isVisibleByLoggedUser = (_, getters, rootState) => name => {
  return getters.isVisibleByUserId({ name, userId: rootState.user.user.id })
}

const getValue = (state, getters) => name => {
  const config = getters.getConfig({ name })
  if (!config?.active) return
  return config.value
}

const getNotification = (state, getters) => config => {
  const stateConfig = getters.getConfig({ key: config.key })

  const shouldNotify =
    stateConfig?.name &&
    (!isEqual(stateConfig.value, transformValue(config)) ||
      !isEqual(stateConfig.active, config.active) ||
      !isEqual(stateConfig.public, config.public))

  if (shouldNotify) {
    return state.notifications.find(n => n.name.includes(config.key))?.message
  }
}

export default {
  getConfig,
  isVisibleByUserId,
  isVisibleByLoggedUser,
  getValue,
  getNotification
}
